export const ENVIRONMENT = {
  DEMO: 'demo',
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  REVIEW_APP: 'review_app'
}

export const ENVIRONMENT_LABEL = {
  [ENVIRONMENT.DEMO]: 'Démonstration',
  [ENVIRONMENT.DEVELOPMENT]: 'Développement',
  [ENVIRONMENT.PRODUCTION]: 'Production',
  [ENVIRONMENT.REVIEW_APP]: 'Recette jetable'
}
